module.exports = __webpack_public_path__ + "img/gongchang.9004bb1d.png";